<ng-container
  *ngIf="{
    off:
      location.controllers.$values
      | getControllerByIndex : propToDisplay.propInfo.controllerIndex
      | findProperty : Property.isHvacRoomControlFancoilOff : updated : true,
    low:
      location.controllers.$values
      | getControllerByIndex : propToDisplay.propInfo.controllerIndex
      | findProperty : Property.isHvacRoomControlFancoilLow : updated : true,
    medium:
      location.controllers.$values
      | getControllerByIndex : propToDisplay.propInfo.controllerIndex
      | findProperty : Property.isHvacRoomControlFancoilMedium : updated : true,
    high:
      location.controllers.$values
      | getControllerByIndex : propToDisplay.propInfo.controllerIndex
      | findProperty : Property.isHvacRoomControlFancoilHigh : updated : true,
    auto:
      location.controllers.$values
      | getControllerByIndex : propToDisplay.propInfo.controllerIndex
      | findProperty : Property.isHvacRoomControlFancoilAuto : updated : true
  } as fancoilModes"
>
  <ng-container
    *ngIf="
      fancoilModes.off.length > 0 ||
      fancoilModes.low.length > 0 ||
      fancoilModes.medium.length > 0 ||
      fancoilModes.high.length > 0 ||
      fancoilModes.auto.length > 0
    "
  >
    <div
      [ngClass]="[displaySize === 'minimal' ? 'status-container-minimal' : '']"
      class="flex-row full-height"
    >
      <div
        [ngStyle]="
          displaySize !== 'minimal' ? { 'margin-left': 'inherit' } : {}
        "
        [ngClass]="[
            propToDisplay.propInfo.activeIcon,
            (displaySize === 'large' || displaySize === 'minimal') &&
            ((fancoilModes.low | propIsActive) ||
              (fancoilModes.medium | propIsActive) ||
              (fancoilModes.high | propIsActive) ||
              (fancoilModes.auto | propIsActive))
              ? 'icon-background-on'
              : '',
            (displaySize === 'large' || displaySize === 'minimal') &&
             !((fancoilModes.low | propIsActive) ||
              (fancoilModes.medium | propIsActive) ||
              (fancoilModes.high | propIsActive) ||
              (fancoilModes.auto | propIsActive))
              ? 'icon-background-off black'
              : ''
          ]"
      ></div>

      <ng-container
        *ngIf="displaySize === 'large' || displaySize === 'minimal'"
      >
        @if (fancoilModes.auto | propIsActive) {

        <div
          class="status-text-on status-text-ellipsis"
          title="{{ text | translate }}: {{ 'Auto' | translate }}"
        >
          {{ text | translate }}: {{ "Auto" | translate }}
        </div>
        } @else if(FANCOIL_MODE_SHOW_STATUS_MANUAL && ((fancoilModes.low |
        propIsActive) || (fancoilModes.medium | propIsActive) ||
        (fancoilModes.high | propIsActive))) {

        <div
          class="status-text-on status-text-ellipsis"
          title="{{ text | translate }}: {{ 'Manual' | translate }}"
        >
          {{ text | translate }}: {{ "Manual" | translate }}
        </div>
        } @else if(fancoilModes.high | propIsActive) {
        <div
          class="status-text-on status-text-ellipsis"
          title="{{ text | translate }}: {{ 'High' | translate }}"
        >
          {{ text | translate }}: {{ "High" | translate }}
        </div>
        } @else if(fancoilModes.medium | propIsActive) {
        <div
          class="status-text-on status-text-ellipsis"
          title="{{ text | translate }}: {{ 'Medium' | translate }}"
        >
          {{ text | translate }}: {{ "Medium" | translate }}
        </div>
        } @else if(fancoilModes.low | propIsActive) {
        <div
          class="status-text-on status-text-ellipsis"
          title="{{ text | translate }}: {{ 'Low' | translate }}"
        >
          {{ text | translate }}: {{ "Low" | translate }}
        </div>
        } @else if(fancoilModes.off | propIsActive) {
        <div
          class="status-text-off status-text-ellipsis"
          title="{{ text | translate }}: {{ 'Off' | translate }}"
        >
          {{ text | translate }}: {{ "Off" | translate }}
        </div>
        } @else {
        <div
          class="status-text-off status-text-ellipsis"
          title="{{ text | translate }}"
        >
          {{ text | translate }}:
        </div>
        }
      </ng-container>
    </div>
  </ng-container>
</ng-container>
